<app-tab-header [hidden]="updatingGrid">
  <div class="row" style="flex-wrap:nowrap">
    <div class="col-md-6">
      <app-standard-config-sync [iProjectId]="iProjectId()" [iProjectTypeId]="iProjectTypeId()" (SyncStandardConfig)="onStdConfigChange($event)">
      </app-standard-config-sync>
    </div>
    <div style="display: flex; justify-content: flex-start; align-items: flex-end;">
      <div>
        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.plusCircle" (click)="this.isItemsDialogOpen = true;">
          Add
        </button>

        <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.xCircle" [disabled]="selectedItems.length == 0" (click)="removeItems()"> Remove</button>
      </div>
    </div>
  </div>
</app-tab-header>

@if (updatingGrid) {
  <kendo-loader type="converging-spinner" size="small" style="margin-left: 1rem;"></kendo-loader>
}

<kendo-grid #grid
  style="margin: 5px 15px 15px 15px;max-height:calc(100% - 6em)"
  [rowClass]="rowCallback"
  [data]="dProjectResourceItem"
  [pageable]="false"
  [skip]="state.skip"
  [sort]="state.sort"
  [filter]="state.filter"
  [filterable]="true"
  [resizable]="true"
  [reorderable]="true"
  [sortable]="true"
  [scrollable]="'scrollable'"
  [groupable]="true"
  [group]="state.group"
  [navigable]="true"
  [selectedKeys]="selectedKeys"
  [kendoGridSelectBy]="'ProjectResourceItemId'"
  (dataStateChange)="onStateChange($event)"
  (selectionChange)="selectionChange($event)"
  [hidden]="updatingGrid"
  (cellClick)="editRow($event)"
  [height]="1200"
  (remove)="removeHandler($event)">
  <kendo-grid-checkbox-column [reorderable]="false" [width]="40" [showSelectAll]="false"></kendo-grid-checkbox-column>

  <kendo-grid-column field="typeDesc" title="Type" [width]="180">
  </kendo-grid-column>
  <kendo-grid-column field="Phase" title="Phase" [width]="180">
  </kendo-grid-column>
  <kendo-grid-column field="Step" title="Step" [width]="180">
  </kendo-grid-column>
  <kendo-grid-column field="Item.ItemNumber" title="Item Number" [width]="180">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-numeric-filter-cell
        [column]="column"
        [format]="'0:n0'"
        [filter]="filter"
        [showOperators]="false"
        [spinners]="false">
      </kendo-grid-numeric-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="Item.ItemShortDescription" title="Item Name">
  </kendo-grid-column>
  <kendo-grid-column field="GFCM" title="GFCM">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell
        [showOperators]="false"
        [column]="column"
        [filter]="filter">
      </kendo-grid-string-filter-cell>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.GFCM }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="Item.UnitOfMeasure.Description" title="UOM">
  </kendo-grid-column>
  <kendo-grid-column field="Quantity" editor="numeric" title="QTY">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-numeric-filter-cell
        [column]="column"
        [format]="'0:n0'"
        [filter]="filter"
        [showOperators]="false"
        [spinners]="false">
      </kendo-grid-numeric-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="EstimateDate" title="Need By Date">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.EstimateDate | date:'shortDate' }}
    </ng-template>
  </kendo-grid-column>
</kendo-grid>

@if (showDeletePopup) {
  <kendo-popup [popupClass]="'content popup'" [anchorAlign]="anchorAlign" [popupAlign]="popupAlign" (anchorViewportLeave)="showDeletePopup = false"
    [popupClass]="'inner-wrapper'">
    <div style="width:400px;height:100px">
      <p style="padding:0px 14px 0px 10px">
        <span style="font-weight:bold">
          Are you sure you want to delete this Item?
        </span>
      </p>
      <kendo-buttongroup [selection]="'single'" [width]="'300'">
        <button type="button" kendoButton themeColor="primary" [togglable]="true" (click)="deleteItem()">
          Delete Item
        </button>
        <button type="button" kendoButton themeColor="primary" [togglable]="true" (click)="cancelDeleteItem()">
          Cancel
        </button>
      </kendo-buttongroup>
    </div>
  </kendo-popup>
}
<app-project-item-select [showDialog]="isItemsDialogOpen" [iProjectTypeId]="iProjectTypeId()" (addItem)="saveNewItem($event)"
  (closeDialog)="closeDialog()">
</app-project-item-select>

@if (displayRemoveItemDialog) {
  <kendo-dialog title="Remove Items" (close)="declineRemoveItems()">
    <p style="margin: 30px; text-align: center;">This action will cause the selected item(s) to be removed. Would you like to proceed?
    </p>
    <kendo-dialog-actions>
      <button type="button" kendoButton (click)="acceptRemoveItems()" themeColor="primary">Yes</button>
      <button type="button" kendoButton (click)="declineRemoveItems()">No</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}